// Single source of per-route SEO used by the pages (useSeo) and by the build-time prerender (scripts/prerender.mjs).
export const SITE_URL = "https://pmnetwork.org";
export const SITE_NAME = "Project Management Network";

export const SEO = {
  "/": {
    title: "Fractional Program Leadership for Critical Initiatives",
    description:
      "PMN helps regulated, growth-stage, and PE-backed organizations assess complex initiatives, establish the right delivery structure, and lead execution through experienced program leaders and PMN-led teams.",
  },
  "/services": {
    title: "Services — Assessment, Fractional Program Leadership, PMN-Led Teams",
    description:
      "Three ways to engage PMN: Assessment and Roadmap, Fractional Program Leadership, and PMN-Led Delivery Teams. Structured as fixed fee, retainer, milestone-based, or time and materials.",
  },
  "/capabilities": {
    title: "Capabilities — Program Assessment, Initiative Leadership, PMO, Governance",
    description:
      "PMN's areas of practice: program assessment and recovery, critical initiative leadership, PMO development, portfolio governance, team enablement, PMN-led delivery teams, and regulatory execution.",
  },
  "/case-studies": {
    title: "Case Studies — PMN Client Engagements and Leadership Experience",
    description:
      "PMN client engagements, published with client approval, and the leadership experience behind PMN across financial services, healthcare, fintech, and defense programs.",
  },
  "/about": {
    title: "About PMN — Brandon Rodgers, Founder & Managing Member",
    description:
      "PMN was legally established in 2020 and became Brandon Rodgers' full-time focus in 2026. A firm built to extend senior program leadership beyond a single consultant.",
  },
  "/contact": {
    title: "Discuss an Initiative",
    description:
      "Tell PMN what initiative or delivery challenge you're working through. We respond within one business day — or book a 30-minute call directly.",
  },
  "/privacy": {
    title: "Privacy Policy",
    description:
      "How Project Management Network handles contact-form data, scheduling via Calendly, analytics cookies, and your choices.",
  },
};

export const PRERENDER_ROUTES = Object.keys(SEO);
